import Vue from 'vue';
import router from '../../../ugsrc/router/index';
import { EventBus } from '../../../common/assets/utils/eventBus';

export function findSelectedAppFromAppsList(allApps, selectedAppToken) {
    for (let i=0; i< allApps.length; i++) {
        let fields = allApps[i]['fields'] || {}
        let serviceDetails = fields['service_details'] || {}
        let appToken = serviceDetails['app_token']
        if (appToken === selectedAppToken) {
            return i;
        }
    }
    return -1;
}
export const appsDetails = {
    namespaced: true,
    state: {
        allApps: [],
        allAppTypes: [],
        // configuration: {
        //     advancedConfiguration: {
        //         enabledServices: [],
        //         disabledServices: []
        //     }
        // }
    },
    getters: {
      
    },
    actions: {
        getAllAppsData({state, commit, dispatch}, data) {
            EventBus.$emit('showLoadingIcon', true);
            Vue.http.get('/services/')
			.then((res) => {
                commit('saveAllAppsData', res.data);
                EventBus.$emit('showLoadingIcon', false);
			}, (error) => {
                commit('saveAllAppsData', []);
                EventBus.$emit('showLoadingIcon', false);
                console.log("Something went Wrong: ", error);
			})
        },
        getAllAppTypes({state, commit, dispatch}, data) {
            EventBus.$emit('showLoadingIcon', true);
            Vue.http.get('/get_apptypes/')
			.then((res) => {
                commit('saveAllAppsTypesData', res.data);
                EventBus.$emit('showLoadingIcon', false);
			}, (error) => {
                commit('saveAllAppsTypesData', []);
                EventBus.$emit('showLoadingIcon', false);
                console.log("Something went Wrong: ", error);
			})
        },
        resetAllAppsData({commit}, data){
            commit('saveAllAppsData', []);
        },
        updatedSources({state, commit, dispatch}, data) {
            EventBus.$emit('showLoadingIcon', true);
            let formData = new FormData();
            formData.append('json',JSON.stringify(data));
            Vue.http.post('/update_datasource/', formData)
			.then((res) => {
                commit('saveUpdatedSources', data );
                EventBus.$emit('showLoadingIcon', false);
			}, (error) => {
                commit('saveUpdatedSources', []);
                EventBus.$emit('showLoadingIcon', false);
                console.log("Something went Wrong: ", error);
			})
        },
        updatedLicences({state, commit, dispatch}, data) {
            EventBus.$emit('showLoadingIcon', true);
            let formData = new FormData();
            formData.append('json',JSON.stringify(data));
            Vue.http.post('/update_datasource/', formData)
			.then((res) => {
                commit('saveUpdatedLicences', data );
                EventBus.$emit('showLoadingIcon', false);
			}, (error) => {
                commit('saveUpdatedLicences', []);
                EventBus.$emit('showLoadingIcon', false);
                console.log("Something went Wrong: ", error);
			})
        },
        updateViewFullPassword({state, commit, dispatch}, data) {
            EventBus.$emit('showLoadingIcon', true);
            let formData = new FormData();
            formData.append('json',JSON.stringify(data));
            Vue.http.post('/update_full_password/', formData)
			.then((res) => {
                commit('saveViewFullPassword', data );
                EventBus.$emit('showLoadingIcon', false);
			}, (error) => {
                EventBus.$emit('showLoadingIcon', false);
                console.log("Something went Wrong: ", error);
			})
        },
        updateSharedInvestigation({state, commit, dispatch}, data) {
            EventBus.$emit('showLoadingIcon', true);
            let formData = new FormData();
            formData.append('json',JSON.stringify(data));
            Vue.http.post('/update_shared_investigation/', formData)
			.then((res) => {
                commit('saveSharedInvestigation', data );
                EventBus.$emit('showLoadingIcon', false);
			}, (error) => {
                EventBus.$emit('showLoadingIcon', false);
                console.log("Something went Wrong: ", error);
			})
        },
        updateEnableDataBrokers({state, commit, dispatch}, data) {
            EventBus.$emit('showLoadingIcon', true);
            let formData = new FormData();
            formData.append('json',JSON.stringify(data));
            Vue.http.post('/update_enable_dataBrokers/', formData)
			.then((res) => {
                commit('saveEnableDataBrokers', data );
                EventBus.$emit('showLoadingIcon', false);
			}, (error) => {
                EventBus.$emit('showLoadingIcon', false);
                console.log("Something went Wrong: ", error);
			})
        }
    },
    mutations: {
        saveAllAppsData(state, appsData){
            state.allApps = appsData;
        },
        saveAllAppsTypesData(state, appsData){
            state.allAppTypes = appsData;
        },
        saveUpdatedSources(state, selectedData) {
            let allApps = JSON.parse(JSON.stringify(state.allApps));
            for (let i=0; i< allApps.length; i++) {
                let fields = allApps[i]['fields'] || {}
                let serviceDetails = fields['service_details'] || {}
                let appToken = serviceDetails['app_token']
                let currentSources = fields['updated_sources']
                let id = selectedData.data_source_id;
                if (appToken === selectedData.apptoken) {
                    if (selectedData.data_source_status) {
                    if (!currentSources.includes(id)) {
                            allApps[i]['fields']['updated_sources'].push(id);
                        }
                    } else {
                        if (currentSources.includes(id)) {
                            let index = currentSources.indexOf(id);
                            allApps[i]['fields']['updated_sources'].splice(index,1);
                        }
                    }
                    Vue.set(state.allApps, i, allApps[i]);
                    break;
                }
            }
        },
        saveViewFullPassword(state, selectedData) {
            let selectedAppIndex = findSelectedAppFromAppsList(state.allApps, selectedData.apptoken);
            if (selectedAppIndex > -1) {
                let appTokenData = {...state.allApps[selectedAppIndex]};
                appTokenData['fields']['full_password'] = selectedData.view_full_password;
                Vue.set(state.allApps, selectedAppIndex, appTokenData);
            }
        },
        saveSharedInvestigation(state, selectedData) {
            let selectedAppIndex = findSelectedAppFromAppsList(state.allApps, selectedData.apptoken);
            if (selectedAppIndex > -1) {
                let appTokenData = {...state.allApps[selectedAppIndex]};
                appTokenData['fields']['shared_investigation'] = selectedData.shared_investigation;
                Vue.set(state.allApps, selectedAppIndex, appTokenData);
            }
        },
        saveEnableDataBrokers(state, selectedData) {
            let selectedAppIndex = findSelectedAppFromAppsList(state.allApps, selectedData.apptoken);
            if (selectedAppIndex > -1) {
                let appTokenData = {...state.allApps[selectedAppIndex]};
                appTokenData['fields']['enable_dataBrokers'] = selectedData.enable_dataBrokers;
                Vue.set(state.allApps, selectedAppIndex, appTokenData);
            }
        }
    },
  };
  